import { Heading, VStack, Text } from '@chakra-ui/react'
import { ConnectWalletButton } from '.'

export const ExtendedConnectWalletButton = ({
  title = 'Please connect your wallet',
  text,
  ...props
}) => {
  return (
    <VStack
      alignItems={'start'}
      p={4}
      spacing={2}
      border={'1px solid'}
      borderColor={'gray.200'}
      rounded={'md'}
      boxShadow={'base'}
      bg={'white'}
      {...props}
    >
      <Heading fontSize={'larger'}>{title}</Heading>

      {text && <Text>{text}</Text>}

      <ConnectWalletButton />
    </VStack>
  )
}
